angular.module('surfsightApp.controllers').controller('EdgeModalController', [
  '$scope',
  '$rootScope',
  '$log',
  '$state',
  '$timeout',
  '$interval',
  '$location',
  '$window',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdSidenav',
  '$mdToast',
  '$mdColors',
  '$mdMedia',
  // 'NgMap',
  'edgeFactoryV2',
  'edgeGroupFactoryV2',
  'broadcastViewFactory',
  'leafletData',
  'nominatimLookUp',
  'dataFromCaller',
  function (
    $scope,
    $rootScope,
    $log,
    $state,
    $timeout,
    $interval,
    $location,
    $window,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdSidenav,
    $mdToast,
    $mdColors,
    $mdMedia,
    edgeFactoryV2,
    edgeGroupFactoryV2,
    broadcastViewFactory,
    leafletData,
    nominatimLookUp,
    dataFromCaller
  ) {
    $scope.data = {}
    $scope.data = dataFromCaller
    $scope.edgeTitle = 'whatWouldYouLikeToAdd'
    $scope.showNotAddedResults = false
    $scope.cancel = function () {
      $mdDialog.cancel()
    }
    $scope.searchLocations = function (query) {
      return nominatimLookUp.querySearch(query)
    }
    $scope.placeChanged = function (place) {
      if (place) {
        $scope.newedge.latitude = parseFloat(place.lat)
        $scope.newedge.longitude = parseFloat(place.lon)
      }
    }
    $scope.change_selected_tab = function (index, addType) {
      $scope.selected_tab = index
      if ($scope.selected_tab == 0) {
        $scope.edgeTitle = 'whatWouldYouLikeToAdd'
      } else if ($scope.selected_tab == 1) {
        $scope.edgeTitle = 'addSurfsightDash'
      } else if ($scope.selected_tab == 2) {
        $scope.edgeTitle = 'addBulk'
        $scope.showNotAddedResults = false
        $scope.addBulk.devices = ''
      } else if ($scope.selected_tab == 3) {
        $scope.edgeTitle = 'addEdgeGroup'
        $scope.addType = 'edge_group'
      } else if ($scope.selected_tab == 4) {
        $scope.edgeTitle = 'scanSerialNumber'
      }
    }

    /* $scope.placeChanged = function() {
            var place = this.getPlace();
            //console.log('location', place.geometry.location);
            $scope.newedge.latitude=place.geometry.location.lat();
            $scope.newedge.longitude=place.geometry.location.lng();
        } */
    $scope.newedge = {}

    $scope.form_submit_inprogress = false
    $scope.isGeoTabOrderNow =
      $localStorage.currentUserOrganization &&
      ($localStorage.currentUserOrganization.partnerId === GEOTAB_RESELLER_ID ||
        $localStorage.currentUserOrganization.reseller_id ===
          GEOTAB_RESELLER_ID)

    const userType = $localStorage.userDetails.type
    const partnerId =
      $localStorage.currentUserOrganization.reseller_id ||
      (userType === 'reseller' ||
      userType === 'sub-reseller' ||
      userType === 'reseller-contact'
        ? $localStorage.userDetails.id
        : null)
    // Check if recording encryption feature is enabled
    $scope.isRecordingEncryptionFeatureEnabled = false
    const featureFlagRequest = {
      method: 'POST',
      url: `${EDGE_BASEURL}/red-recording-encryption-feature`,
      data: {
        partnerId
      }
    }

    $http(featureFlagRequest)
      .then(featureFlagResponse => {
        $scope.isRecordingEncryptionFeatureEnabled =
          featureFlagResponse.data.enabled || false
      })
      .catch(featureFlagError => {
        console.error(
          'Failed to check encryption feature flag:',
          featureFlagError
        )
        $scope.isRecordingEncryptionFeatureEnabled = false
      })
    $scope.addEdge = function () {
      $scope.form_submit_inprogress = true
      if ($scope.newedge.name && $scope.newedge.uri) {
        edgeFactoryV2
          .addDevice(
            $rootScope.currentUserOrganization.id,
            $scope.newedge.uri,
            $scope.newedge.name
          )
          .then(
            function (response) {
              $scope.showMessageToast('Operation Successful')
              response.data.type = 'edge'

              // Check if device is AI-14
              const isAI14Device = window.isAI14Device($scope.newedge.uri)

              // Only generate encryption keys if feature is enabled and device is AI-14
              if ($scope.isRecordingEncryptionFeatureEnabled && isAI14Device) {
                const encryptionKeyRequest = {
                  method: 'POST',
                  url: `${V2_BASEURL}/organizations/${$rootScope.currentUserOrganization.id}/get-recording-encryption-keys`,
                  data: { imeis: [$scope.newedge.uri] }
                }

                const showEncryptionKeysDialog = (
                  encryptionKeys,
                  success,
                  errorMessage
                ) => {
                  $mdDialog.show({
                    templateUrl:
                      './templates/encryption-keys.view.html?t=' +
                      window.webpackHash,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false,
                    controller: [
                      '$scope',
                      '$mdDialog',
                      '$mdToast',
                      function ($scope, $mdDialog, $mdToast) {
                        $scope.encryptionKeys = encryptionKeys
                        $scope.success = success
                        $scope.errorMessage = errorMessage

                        $scope.copyToClipboard = function (text) {
                          if (
                            navigator.clipboard &&
                            navigator.clipboard.writeText
                          ) {
                            navigator.clipboard.writeText(text).then(
                              function () {
                                const toast = $mdToast
                                  .simple()
                                  .textContent(
                                    'Encryption key copied to clipboard'
                                  )
                                  .position('bottom')
                                  .hideDelay(2000)
                                $mdToast.show(toast)
                              },
                              function (err) {
                                console.error('Failed to copy: ', err)
                              }
                            )
                          } else {
                            // Fallback for older browsers
                            const textArea = document.createElement('textarea')
                            textArea.value = text
                            textArea.style.position = 'fixed'
                            textArea.style.left = '-999999px'
                            document.body.appendChild(textArea)
                            textArea.select()
                            try {
                              document.execCommand('copy')
                              const toast = $mdToast
                                .simple()
                                .textContent(
                                  'Encryption key copied to clipboard'
                                )
                                .position('bottom')
                                .hideDelay(2000)
                              $mdToast.show(toast)
                            } catch (err) {
                              console.error('Failed to copy: ', err)
                            }
                            document.body.removeChild(textArea)
                          }
                        }

                        $scope.cancel = function () {
                          $mdDialog.cancel()
                        }
                      }
                    ]
                  })
                }
                $mdDialog.hide(response)
                $http(encryptionKeyRequest)
                  .then(encryptionResponse => {
                    $scope.form_submit_inprogress = false
                    const encryptionKeys = encryptionResponse.data.keys || []
                    showEncryptionKeysDialog(encryptionKeys, true, null)
                  })
                  .catch(encryptionError => {
                    $scope.form_submit_inprogress = false
                    const errorMessage =
                      (encryptionError.data && encryptionError.data.message) ||
                      'Failed to generate encryption keys'
                    showEncryptionKeysDialog([], false, errorMessage)
                  })
              } else {
                // Feature disabled or not AI-14 device - just close dialog
                $mdDialog.hide(response)
                $scope.form_submit_inprogress = false
              }
            },
            function (error) {
              $scope.form_submit_inprogress = false
              handleServerError(error)
              $scope.showMessageToast(error.data.message)
            }
          )
      }
    }

    $scope.addBulk = () => {
      const devices = $scope.addBulk.devices
        .split('\n')
        .map(row => row.split(', '))
        .map(([imei, name]) => ({
          imei,
          name: name.replace(/['"]+/g, '')
        }))
      const request_json = {
        method: 'POST',
        url: `${V2_BASEURL}/organizations/${$rootScope.currentUserOrganization.id}/bulk-devices`,
        data: devices
      }
      $http(request_json).then(
        function (response) {
          $scope.showMessageToast(
            response.status === 200
              ? 'Operation successful'
              : 'Operation failed'
          )

          const hasAccepted =
            response.status === 200 &&
            response.data.data &&
            response.data.data.accepted &&
            response.data.data.accepted.length > 0

          const hasRejected =
            response.data.data &&
            response.data.data.rejected &&
            response.data.data.rejected.length > 0

          if (hasAccepted) {
            // Set the response type to trigger device list refresh
            response.data.type = 'edge'

            // Only generate encryption keys if feature is enabled
            if ($scope.isRecordingEncryptionFeatureEnabled) {
              // Filter only AI-14 devices from accepted devices
              const acceptedImeis = response.data.data.accepted
                .filter(device => {
                  const deviceImei =
                    device.imei ||
                    device.uri ||
                    device.serialNumber ||
                    device.deviceId
                  const isAI14 = deviceImei
                    ? window.isAI14Device(deviceImei)
                    : false
                  return isAI14
                })
                .map(
                  device =>
                    device.imei ||
                    device.uri ||
                    device.serialNumber ||
                    device.deviceId
                )

              // Only proceed if there are AI-14 devices
              if (acceptedImeis.length > 0) {
                const encryptionKeyRequest = {
                  method: 'POST',
                  url: `${V2_BASEURL}/organizations/${$rootScope.currentUserOrganization.id}/get-recording-encryption-keys`,
                  data: { imeis: acceptedImeis }
                }

                const showEncryptionKeysDialog = (
                  encryptionKeys,
                  success,
                  errorMessage
                ) => {
                  $mdDialog.show({
                    templateUrl:
                      './templates/encryption-keys.view.html?t=' +
                      window.webpackHash,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false,
                    controller: [
                      '$scope',
                      '$mdDialog',
                      '$mdToast',
                      function ($scope, $mdDialog, $mdToast) {
                        $scope.encryptionKeys = encryptionKeys
                        $scope.success = success
                        $scope.errorMessage = errorMessage

                        $scope.copyToClipboard = function (text) {
                          if (
                            navigator.clipboard &&
                            navigator.clipboard.writeText
                          ) {
                            navigator.clipboard.writeText(text).then(
                              function () {
                                const toast = $mdToast
                                  .simple()
                                  .textContent(
                                    'Encryption key copied to clipboard'
                                  )
                                  .position('bottom')
                                  .hideDelay(2000)
                                $mdToast.show(toast)
                              },
                              function (err) {
                                console.error('Failed to copy: ', err)
                              }
                            )
                          } else {
                            // Fallback for older browsers
                            const textArea = document.createElement('textarea')
                            textArea.value = text
                            textArea.style.position = 'fixed'
                            textArea.style.left = '-999999px'
                            document.body.appendChild(textArea)
                            textArea.select()
                            try {
                              document.execCommand('copy')
                              const toast = $mdToast
                                .simple()
                                .textContent(
                                  'Encryption key copied to clipboard'
                                )
                                .position('bottom')
                                .hideDelay(2000)
                              $mdToast.show(toast)
                            } catch (err) {
                              console.error('Failed to copy: ', err)
                            }
                            document.body.removeChild(textArea)
                          }
                        }

                        $scope.cancel = function () {
                          $mdDialog.cancel()
                        }
                      }
                    ]
                  })
                }

                $mdDialog.hide(response)

                $http(encryptionKeyRequest)
                  .then(encryptionResponse => {
                    $scope.form_submit_inprogress = false
                    const encryptionKeys = encryptionResponse.data.keys || []
                    showEncryptionKeysDialog(encryptionKeys, true, null)
                  })
                  .catch(encryptionError => {
                    $scope.form_submit_inprogress = false
                    const errorMessage =
                      (encryptionError.data && encryptionError.data.message) ||
                      'Failed to generate encryption keys'
                    showEncryptionKeysDialog([], false, errorMessage)
                  })
              } else {
                // No AI-14 devices - just close dialog
                $mdDialog.hide(response)
                $scope.form_submit_inprogress = false
              }
            } else {
              // Feature disabled - just close dialog
              $mdDialog.hide(response)
              $scope.form_submit_inprogress = false
            }
          } else if (hasRejected) {
            let result = ''
            response.data.data.rejected.map(item => {
              result += item.imei + ', ' + item.name + '<br>'
            })
            $scope.addBulk.rejected = result
            $scope.showNotAddedResults = true
          } else {
            $mdDialog.hide(response)
            $scope.form_submit_inprogress = false
          }
        },
        function (response) {
          $scope.form_submit_inprogress = false
          handleServerError(response)
          $scope.showMessageToast(response.data.message)
        }
      )
    }

    var attributeRemover = $interval(function () {
      if (document.getElementById('search-location')) {
        document
          .getElementById('search-location')
          .removeAttribute('placeholder')
      }
    }, 100)
    $scope.$on('$destroy', function () {
      $interval.cancel(attributeRemover)
      $scope.stop_scanner_camera()
    })

    $scope.showMessageToast = function (message) {
      var toast = $mdToast
        .simple()
        .textContent(message)
        .action('ok')
        .position('bottom middle')
        .actionKey('F1')
        .hideDelay(3000)
        .parent('#core-container')

      $mdToast
        .show(toast)
        .then(function (response) {
          if (response == 'ok') {
            // alert('You clicked the \'UNDO\' action.');
          }
        })
        .catch(() => {})
    }
    $scope.selected_tab = 0
    $scope.scanner_type = 'barcode'
    $scope.qr_code_scanner = {
      start_scanning: function () {
        $scope.qr_code_scanner.cameraRequested = true
        $scope.qr_code_scanner.cameraIsOn = true
        $scope.scanning_in_prgress = true
      },
      stop_scanning: function () {
        $scope.qr_code_scanner.cameraRequested = false
        $scope.qr_code_scanner.cameraIsOn = false
        $scope.scanning_in_prgress = false
      },
      toggle_scanning: function () {
        if ($scope.qr_code_scanner.cameraIsOn) {
          $scope.qr_code_scanner.stop_scanning()
        } else {
          $scope.qr_code_scanner.start_scanning()
        }
      },
      processURLfromQR: function (url) {
        $scope.qr_code_scanner.url = url
        $scope.qr_code_scanner.toggle_scanning()
        $scope.scanned_serial_number = url
      },
      onError: function (error = null) {
        console.log('error in sanning')
        console.log(error)
      },
      cameraRequested: false,
      cameraIsOn: false
    }
    $scope.show_scanner = function () {
      $scope.change_selected_tab(4)
      $scope.scanner_type = undefined
      $scope.select_scanner('barcode') // currently QR code scanning is not included in the application
    }
    $scope.hide_scanner = function () {
      if ($scope.scanner_type == 'qr') {
        $scope.qr_code_scanner.stop_scanning()
      }
      if ($scope.scanner_type == 'barcode') {
        $scope.bar_code_scanner.stop_scanning()
      }
      $timeout(function () {
        $scope.change_selected_tab(1)
      }, 300)
    }
    $scope.scan_completed = function () {
      $scope.newedge.uri = angular.copy($scope.scanned_serial_number)
      $scope.stop_scanner_camera()
      $scope.hide_scanner()
    }
    $scope.enter_scanner_fullscreen = function () {
      if ($scope.scanner_type == 'qr') {
        $scope.qr_code_scanner.fullScreen = true
      }
      if ($scope.scanner_type == 'barcode') {
        $scope.bar_code_scanner.fullScreen = true
      }
    }
    $scope.select_scanner = function (type = 'barcode') {
      if (type == 'barcode') {
        if ($scope.scanner_type == 'qr') {
          $scope.qr_code_scanner.stop_scanning()
        }
        $scope.scanner_type = type
        $scope.selectedCamera = $scope.getBackcamera()
        $timeout(function () {
          $scope.bar_code_scanner.start_scanning()
        }, 200)
      } else if (type == 'qr') {
        if ($scope.scanner_type == 'barcode') {
          $scope.bar_code_scanner.stop_scanning()
        }
        $scope.scanner_type = type
        $timeout(function () {
          $scope.qr_code_scanner.start_scanning()
        }, 200)
      }
    }
    $scope.backCameraFound = false
    $scope.getBackcamera = function () {
      var returnValue = undefined
      $scope.availableCameras.forEach(function (c) {
        if (c.name.indexOf('back') > 0 || c.name.indexOf('2') > 0) {
          returnValue = c.deviceId
        }
      })
      if (!returnValue) {
        returnValue = $scope.availableCameras[0]
          ? $scope.availableCameras[0].deviceId
          : undefined
      }
      return returnValue
    }
    $scope.bar_code_scanner = {
      start_scanning: function () {
        $scope.scanning_in_prgress = true
        $scope.bar_code_scanner.cameraIsOn = true
      },
      stop_scanning: function () {
        $scope.bar_code_scanner.cameraIsOn = false
        $scope.scanning_in_prgress = false
      },
      toggle_scanning: function () {
        if ($scope.bar_code_scanner.cameraIsOn) {
          $scope.bar_code_scanner.stop_scanning()
        } else {
          $scope.bar_code_scanner.start_scanning()
        }
      },
      onProcessed: function (result) {},
      onDetected: function (result) {
        $scope.bar_code_scanner.fullScreen = false
        $scope.bar_code_scanner.stop_scanning()
        $scope.scanned_serial_number = result.codeResult.code
        $scope.scan_completed()
      },
      cameraIsOn: false,
      cameraId: undefined,
      fullScreen: false,
      fullScreenTracker: function (isFullScreen) {
        this.fullScreen = isFullScreen
      }
    }
    $scope.availableCameras = []
    var gotDevices = false
    $scope.loading
    $scope.loadCameras = function () {
      function gotDevices (deviceInfos) {
        // alert(JSON.stringify(deviceInfos));
        var tempCameras = []
        for (var i = 0; i !== deviceInfos.length; ++i) {
          var deviceInfo = deviceInfos[i]
          if (deviceInfo.kind === 'videoinput') {
            tempCameras.push({
              deviceId: deviceInfo.deviceId,
              name: deviceInfo.label || 'camera ' + (tempCameras.length + 1)
            })
          }
        }
        $scope.availableCameras = tempCameras
        gotDevices = true
      }

      function errorCallback (err) {
        // console.log('got error');
        // alert(err);
        // console.log(err);
      }

      navigator.mediaDevices
        .enumerateDevices()
        .then(gotDevices)
        .catch(errorCallback)
      $timeout(function () {
        if ($scope.availableCameras.length == 0) {
          $scope.loadCameras()
        }
      }, 1000)
    }
    $scope.loadCameras()
    $scope.scanned_serial_number = undefined
    $scope.scanning_in_prgress = false
    $scope.show_barcode_scanner = function () {
      $scope.selected_tab = 1
      $scope.qr_code_scanner.start_scanning()
    }
    $scope.hide_barcode_scanner = function () {
      $scope.selected_tab = 0
      $scope.qr_code_scanner.stop_scanning()
    }
    $scope.barcode_scan_completed = function () {
      $scope.newedge.uri = angular.copy($scope.scanned_serial_number)
      $scope.hide_scanner()
    }
    $scope.toggle_scanner_camera = function () {
      if ($scope.scanner_type == 'qr') {
        $scope.qr_code_scanner.toggle_scanning()
      }
      if ($scope.scanner_type == 'barcode') {
        $scope.bar_code_scanner.toggle_scanning()
      }
    }
    $scope.stop_scanner_camera = function () {
      if ($scope.scanner_type == 'qr') {
        $scope.qr_code_scanner.stop_scanning()
      }
      if ($scope.scanner_type == 'barcode') {
        $scope.bar_code_scanner.stop_scanning()
      }
    }
    // Add edge group

    $scope.newEdgeGroup = {}
    $scope.form_submit_inprogress = false

    $scope.addEdgeGroup = function () {
      $scope.form_submit_inprogress = true
      $scope.newEdgeGroup.orgId = $rootScope.currentUserOrganization.id

      edgeGroupFactoryV2
        .addGroup(
          $rootScope.currentUserOrganization.id,
          $scope.newEdgeGroup.name
        )
        .then(
          function ({ data: { data } }) {
            $scope.showMessageToast('Operation successful')
            $mdDialog.hide({
              data: {
                ...data,
                organizationId: $rootScope.currentUserOrganization.id
              }
            })
            $scope.form_submit_inprogress = false
          },
          function (error) {
            $scope.form_submit_inprogress = false
            handleServerError(error)
            $scope.showMessageToast(error.data.message)
          }
        )
    }

    function handleServerError (response) {
      $scope.$emit('handleServerError', response)
    }

    $scope.cancelScan = function () {
      $scope.selected_tab = 1
    }
  }
])
